<!-- Page -->
<div class="col no-overflow padding all fill">
  <div class="row flex">

    <app-structure-card>
    </app-structure-card>

  </div>
  <div class="row no-overflow">

    <!-- Find Structures -->
    <mat-card class="no-overflow fill padding all margin all custom-height">
      
      <!-- Header -->
      <mat-card-header class="header-container margin lrg bottom">
        <mat-card-title>Key Systems</mat-card-title>

        <button
          mat-flat-button
          (click)="openDialog()"
          class="new-button"
        >
          New Independent System
        </button>
      </mat-card-header>
      <mat-divider></mat-divider>
      <!-- No Structures -->
      <app-nothing-here margin="128" *ngIf="!structure && !loading.isLoading">
        <h5>
          We couldn't find any Key Systems.
        </h5>
      </app-nothing-here>

      <!-- Key Systems Data Table -->
      <app-data-table
        *ngIf="structure"
        class="card-table"
        #table
        [tableName]="'KeySystems'"
        [viewPageSize]="50"
        [displayColumns]="keyingDisplayColumns"
        [subject]="filteredKeySystems"
        [pagination]="true"      
        (onFilter)="updateSearch()"
        (rowClick)="selectKeySystem($event)"
        [deleteElement]="allowDeleteElement()"
        [showDeleteKeySystem]="true">
      </app-data-table>
    </mat-card>

  </div>
</div>
